export default function iconNameForPath(path: string): string | null {
	const match =
		/\/([^/]+)\.icon\.svg/.exec(path) ?? /\/([^/]+)\.svg/.exec(path);
	if (!match) {
		console.warn(`${path} does not look like a valid SVG icon path`);
		return null;
	}
	return match[1];
}
